import { getFormNames, isSubmitting } from 'redux-form'

const purchasePathForms = ['address', 'addressSelection', 'shippingAddress', 'shippingOptions', 'packagingOptions', 'paymentOptions', 'loginOrGuest']

export default function getSpinner(state) {
    const formNames = getFormNames()(state).filter((name) => !purchasePathForms.includes(name))

    const loading =
        (state.isUpdatingLineItem && Object.keys(state.isUpdatingLineItem).length > 0) ||
        (state.isRemovingLineItem && Object.keys(state.isRemovingLineItem).length > 0) ||
        (state.isUndoingRemoveLineItem && Object.keys(state.isUndoingRemoveLineItem).length > 0) ||
        (state.isMovingToWishlist && Object.keys(state.isMovingToWishlist).length > 0) ||
        (state.isUndoingMoveToWishlist && Object.keys(state.isUndoingMoveToWishlist).length > 0) ||
        (state.isAddingPromotion && Object.keys(state.isAddingPromotion).length > 0) ||
        (state.isRemovingPromotion && Object.keys(state.isRemovingPromotion).length > 0) ||
        state.isRemovingLineItems ||
        state.isUpdatingPayment === true ||
        !!formNames.find((name) => isSubmitting(name)(state)) ||
        false

    return { loading }
}
